<template>
<el-drawer title="职务变更" :visible.sync="show" :before-close="close" :close-on-press-escape="false" :destroy-on-close="true" :wrapperClosable="false" :size="400">
	<p style="font-size: 20px;font-weight: 700;padding-left: 10px;margin-bottom: 20px;">将<span style="color: #f00;">{{name}}</span>的职务变更为：</p>
	<el-form :model="form" :rules="rules" ref="form" label-width="100px">
		<el-form-item class="item" label="主要职务" prop="firstjob">
			<el-select v-model="form.firstjob" placeholder="主要职务" @change="firstjobchange"><el-option v-for="onejob in job" :key="'firstjob'+onejob.id" :label="onejob.name" :value="onejob.id"></el-option></el-select>
		</el-form-item>
		
		<el-form-item class="item" label="次要职务" prop="job">
			<el-select multiple v-model="form.job" placeholder="次要职务"><el-option v-for="onejob in job" :key="'job'+onejob.id" :label="onejob.name" :value="onejob.id" :disabled="form.firstjob===onejob.id ? true : false"></el-option></el-select>
		</el-form-item>
		
		<el-form-item class="item" label="起始日期" prop="startTimeS">
			<el-date-picker style="width: 200px;" v-model="form.startTimeS" type="date" placeholder="选择日期"></el-date-picker>
		</el-form-item>
		
		<div class="m15" style="text-align: right;">
			<el-button @click="reset">重置</el-button>
			<el-button type="primary" @click="submit">提交</el-button>
		</div>
	</el-form>
</el-drawer>
</template>

<script>
export default{
	name:'repjob',
	data() {
		return {
			name:"",
			firstjob:"",
			otherjob:[],
			startTimeS:"",
			form:{
				firstjob:"",
				job:[],
				startTimeS:""
			},
			rules:{
				firstjob:[{validator:(rule,value,callback)=>{
					if(this.form.firstjob===""){
						callback("请选择主要职务")
						return
					}
					if(this.form.firstjob===this.firstjob&&this.myfun.objIsSame(this.form.job,this.otherjob)&&this.startTimeS===this.myfun.date2str(this.form.startTimeS)){
						callback("校区未更改")
						return
					}
					callback()
				},trigger:'blur'}],
				job:[{validator:(rule,value,callback)=>{
					if(this.form.firstjob===this.firstjob&&this.myfun.objIsSame(this.form.job,this.otherjob)&&this.startTimeS===this.myfun.date2str(this.form.startTimeS)){
						callback("校区未更改")
						return
					}
					callback()
				},trigger:'blur'}],
				startTimeS:[{validator:(rule,value,callback)=>{
					if(this.form.startTimeS===""){
						callback("请选择起始日期")
					}
					callback()
				},trigger:'blur'}]
			}
		}
	},
	props:{
		user:{
			type:Object
		},
		show:{
			type:Boolean
		},
		job:{
			type:Array
		}
	},
	watch:{
		show(n){
			if(!n){
				return
			}
			this.name=this.user.name
			this.firstjob=this.user.job[0].id,
			this.form.firstjob=this.user.job[0].id,
			this.otherjob=[]
			this.form.job=[]
			for(let i=1;i<this.user.job.length;i++){
				this.otherjob.push(this.user.job[i].id)
				this.form.job.push(this.user.job[i].id)
			}
			this.startTimeS=this.user.job[0].stime
			this.form.startTimeS=this.user.job[0].stime
		}
	},
	methods:{
		close(){
			this.$emit("close",{isrep:false})
		},
		firstjobchange(){
			this.form.job=[]
		},
		reset(){
			this.$refs.form.resetFields()
		},
		submit(){
			this.$refs.form.validate((e)=>{
				if(!e){
					return
				}
				//整理数据，提交服务器
				let user={
					id:this.user.id,
					job:[],
				}
				let stime=this.myfun.date2str(this.form.startTimeS)
				user.job.push({id:this.form.firstjob,isfirst:true,stime})
				this.form.job.forEach(e=>{
					user.job.push({id:e,isfirst:false,stime})
				})
				this.myfun.Loading()
				const formdata = new FormData()
				formdata.append("user",JSON.stringify(user))
				this.axios.post("data:repjob",formdata).then(e=>{
					this.myfun.Loadingclose()
					if(!e)return
					this.myfun.messageSuc("修改成功")
					this.$emit("close",{isrep:true,data:e})
				})
			})
		}
	}
}
</script>

<style>
</style>
